import { db } from '../firebase/firebase';
import { photoSaved } from './user';
import {
  SELECT_DATE,
  SELECT_TIME,
  SELECT_DURATION,
  SELECT_REASON,
  SELECT_EMOJI,
  MEDITATION_SAVING_SUCCESS,
  MEDITATION_SAVING_ERROR,
  SIGNUP_COMPLETE,
  GET_MEDITATIONS,
  SAVE_MEDITATION_LINK,
  SAVE_MEDITATION_GRADIENT,
  DATA_IS_BEING_FETCHED,
  DATA_FETCH_SUCCESS,
  SET_MEDITATION_ID,
  RESET_MEDITATION_STATE,
} from '../constants/types';

export const selectDay = (date) => {
  return {
    type: SELECT_DATE,
    payload: date
  }
};

export const selectTime = (time, history) => {
  return dispatch => {
    dispatch({
      type: SELECT_TIME,
      payload: time,
    });

    if (history) {
      history.push('/duration');
    }
  };
};

export const selectDuration = (duration) => {
  return {
    type: SELECT_DURATION,
    payload: duration,
  }
};

export const selectReason = (reason, emoji) => {
  return dispatch => {
    dispatch({
      type: SELECT_REASON,
      payload: reason,
    });
    dispatch(selectEmoji(emoji));
  }
};

function selectEmoji (emoji) {
  return {
    type: SELECT_EMOJI,
    payload: emoji,
  }
}

function setMeditationId (meditationId) {
  return {
    type: SET_MEDITATION_ID,
    payload: meditationId,
  }
}

export const getMeditations = (userId) => {
  return dispatch => {
    db.collection('users').doc(userId).collection('meditations').get()
      .then(meditations => {
        dispatch({
          type: GET_MEDITATIONS,
          payload: meditations,
        })
      })
      .catch(error => {
        console.error(error);
      })
  }
};

export const getMeditationData = (userId, meditationRef) => {
  return dispatch => {
    dispatch({ type: DATA_IS_BEING_FETCHED });

    db.collection('users').doc(userId).collection('meditations').doc(meditationRef).get()
      .then(meditation => {
        const newMeditation = meditation.data();
        // dispatch(selectDay(newMeditation.date));
        // dispatch(selectTime(newMeditation.time));
        if (newMeditation.duration) {
          dispatch(selectDuration(newMeditation.duration));
        }
        dispatch(selectReason(newMeditation.reason));
        dispatch(setMeditationLink(newMeditation.meditationLink));
        dispatch(selectEmoji(newMeditation.emoji));
        dispatch(photoSaved(newMeditation.photoRef));
        dispatch({ type: DATA_FETCH_SUCCESS });

        if (newMeditation.gradient) {
          dispatch(setMeditationGradient(newMeditation.gradient));
        }
      })
  }
};

export const setMeditationGradient = (gradient) => {
  return {
    type: SAVE_MEDITATION_GRADIENT,
    payload: gradient,
  }
};

function setMeditationLink (meditationLink) {
  return {
    type: SAVE_MEDITATION_LINK,
    payload: meditationLink,
  }
}

function saveMeditationLink (meditationRef, userId) {
  return dispatch => {
    const meditationLink = `/invitation/${userId}/${meditationRef}`;

    db.collection('users').doc(userId).collection('meditations').doc(meditationRef).set({ meditationLink }, { merge: true })
      .then(() => {
        dispatch(setMeditationLink(meditationLink));
      })
      .catch(error => {
        console.error(error);
      })
  }
}

export const saveMeditationGradient = (userId, meditationRef, gradient) => {
  return dispatch => {
    db.collection('users').doc(userId).collection('meditations').doc(meditationRef).set({ gradient }, { merge: true })
      .then(() => {
        dispatch(setMeditationGradient(gradient));
      })
      .catch(error => {
        console.error(error);
      })
  }
};

export const selectOtherReason = (reason, emoji, history) => {
  return dispatch => {
    dispatch(selectReason(reason));
    dispatch(selectEmoji(emoji));
    history.push('/add_photo');
  }
};

export const saveMeditation = (userId, reason, emoji, history) => {
  return dispatch => {
    db.collection('users').doc(userId).collection('meditations').add({
      reason,
      emoji,
    })
      .then((meditationRef) => {
        localStorage.setItem('newMeditationRef', meditationRef.id);

        dispatch(saveMeditationLink(meditationRef.id, userId));
        dispatch({
          type: MEDITATION_SAVING_SUCCESS,
          payload: meditationRef.id,
        });
        dispatch({
          type: SIGNUP_COMPLETE,
          payload: userId,
        });

        history.push(`/preview/${userId}/${meditationRef.id}`);
      })
      .catch(() => {
        dispatch({ type: MEDITATION_SAVING_ERROR });
      })
  }
};

// Code parts used for experiments

export const saveMeditationWithoutUser = (reason, emoji, history) => {
  return dispatch => {
    db.collection('meditations').add({
      reason,
      emoji,
    })
      .then((meditationRef) => {
        localStorage.setItem('newMeditationRef', meditationRef.id);

        dispatch({
          type: MEDITATION_SAVING_SUCCESS,
          payload: meditationRef.id,
        });
        dispatch(selectReason(reason));
        dispatch(selectEmoji(emoji));
        history.push(`/start/${meditationRef.id}`);
      })
      .catch(error => {
        console.log(error);
      })
  }
};

export const saveOtherWithoutUser = (reason, emoji, history) => {
  return dispatch => {
    db.collection('meditations').add({
      reason,
      emoji,
    })
      .then((meditationRef) => {
        localStorage.setItem('newMeditationRef', meditationRef.id);

        dispatch({
          type: MEDITATION_SAVING_SUCCESS,
          payload: meditationRef.id,
        });
        dispatch(selectReason(reason));
        dispatch(selectEmoji(emoji));
        history.push(`/start/${meditationRef.id}`);
      })
      .catch(error => {
        console.log(error);
      })
  }
};

export const loadMeditationData = (meditationId) => {
  return dispatch => {
    dispatch({ type: DATA_IS_BEING_FETCHED });
    db.collection('meditations').doc(meditationId).get()
      .then(meditation => {
        const newMeditation = meditation.data();

        dispatch(selectReason(newMeditation.reason));
        dispatch(selectEmoji(newMeditation.emoji));
        dispatch(setMeditationId(meditationId));
        dispatch({ type: DATA_FETCH_SUCCESS });
      })
      .catch(error => {
        console.error(error);
      })
  }
};

export const saveDuration = (duration, userId, meditationRef) => {
  return dispatch => {
    db.collection('users').doc(userId).collection('meditations').doc(meditationRef).set({ duration }, { merge: true })
      .then(() => {
        dispatch(selectDuration(duration));
      })
      .catch(error => {
        console.error(error);
      })
  }
};

export const resetState = () => {
  return { type: RESET_MEDITATION_STATE }
};



// WEBPACK FOOTER //
// ./src/actions/newMeditation.js